var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var FORM_VALIDATIONS = {
  PHONE: [{
    pattern: "^\\+?[-\\s./0-9()]+$",
    message: "forms.common.validation_messages.invalidPhone"
  }, {
    message: "forms.common.validation_messages.maxPhoneLength",
    validator: /* @__PURE__ */ __name(function validator(_, value) {
      return value && value.length > 15 ? Promise.reject() : Promise.resolve();
    }, "validator")
  }]
};
export {
  FORM_VALIDATIONS
};
